import Vue from 'vue'
import moment from 'moment'


Vue.filter('formatDate', value => {
	if (value) {
		return moment(String(value)).isValid() ? moment(String(value)).format('MMM Do YYYY') : 'Invalid Date'
	}
	return value
})

Vue.filter('formatDateTime', value => {
	if (value) {
		return moment(String(value)).isValid() ? moment(String(value)).format('MMM Do YYYY HH:mm') : 'Invalid Date'
	}
	return value
})

Vue.filter('formatTime', value => {
	if (value) {
		return moment(String(value)).isValid() ? moment(String(value)).format('HH:mm') : 'Invalid Date'
	}
	return value
})
Vue.filter('formatDuration', value => {
	if (+value === 0) return "";
	if (value) {
		let h = value / 60 | 0,
			m = value % 60 | 0,
			duration = '';
		duration += h+"h"
		m = m+""
		duration += _.padStart(m,2,'0')
		return duration
	}
	else return ''
	// return value
})
Vue.filter('formatPrice', value => {
	if (value) {
		var formatter = new Intl.NumberFormat(undefined, {
			style: 'currency',
			currency: 'CHF'
		});
		return formatter.format(+value)
	}
	else value = ''
	return value
})
Vue.filter('formatTimeFromMinutes', value => {
	let nbHours = Math.floor(value/60);
	let nbMinutes = value - (nbHours*60);
	let text = "";
	if (nbHours) text += nbHours+" h "
	if (nbMinutes) text += nbMinutes+" m"
	return text;
})

Vue.filter('nl2br', value => {
	return value.replace('\n', '<br>')
})

Vue.filter('formatPermissions', item => {
	let perms = []
	_.forEach(item, (value, key) => {
		if (key.indexOf('permission') > -1 && value) {
			perms.push(key.replace('_permission', ''))
		}
	})
	return (perms.length) ? perms.join(', ') : '-'
})

Vue.filter('initials', value => {
	let initials = '';
	let words = value.split(" ");
	_.forEach(words, w => {
		initials += (w.substring(0,1).toUpperCase())
	})
	return initials
})
